"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _component = _interopRequireDefault(require("@loadable/component"));
var _clsx = _interopRequireDefault(require("clsx"));
var _isEmpty = _interopRequireDefault(require("lodash/isEmpty"));
var _useTheme = _interopRequireDefault(require("@material-ui/core/styles/useTheme"));
var _useMediaQuery = _interopRequireDefault(require("@material-ui/core/useMediaQuery"));
var _Container = _interopRequireDefault(require("@material-ui/core/Container"));
var _Typography = _interopRequireDefault(require("@material-ui/core/Typography"));
var _PageContext = _interopRequireDefault(require("@micado-digital/react-ui/context/PageContext"));
var _useIsCurrentLocation = _interopRequireDefault(require("@micado-digital/react-ui/hooks/useIsCurrentLocation"));
var _useLocals = _interopRequireDefault(require("@micado-digital/react-ui/hooks/useLocals"));
var _Local = _interopRequireDefault(require("@micado-digital/react-ui/components/Local"));
var _fireCustomEvent = _interopRequireDefault(require("@micado-digital/react-ui/utils/fireCustomEvent"));
var _de = _interopRequireDefault(require("../../locals/de.json"));
var _en = _interopRequireDefault(require("../../locals/en.json"));
var _it = _interopRequireDefault(require("../../locals/it.json"));
var _CartContext = _interopRequireDefault(require("../../context/CartContext"));
var _ShopContext = _interopRequireDefault(require("../../context/ShopContext"));
var _ProductDetailContext = _interopRequireDefault(require("../../ProductDetail/context/ProductDetailContext"));
var _Availability = _interopRequireDefault(require("./Availability"));
var _BackButton = _interopRequireDefault(require("./BackButton"));
var _Bookmark = _interopRequireDefault(require("./Bookmark"));
var _CartButton = _interopRequireDefault(require("./CartButton"));
var _CombinationSelection = _interopRequireDefault(require("./CombinationSelection"));
var _Gallery = _interopRequireDefault(require("./Gallery"));
var _ItemNumber = _interopRequireDefault(require("./ItemNumber"));
var _Price = _interopRequireDefault(require("./Price"));
var _Quantity = _interopRequireDefault(require("./Quantity"));
var _Rating = _interopRequireDefault(require("./Rating"));
var _Tags = _interopRequireDefault(require("./Tags"));
var _Title = _interopRequireDefault(require("./Title"));
var _VoucherSelection = _interopRequireDefault(require("./VoucherSelection"));
var _getAvailability = _interopRequireDefault(require("../../utils/getAvailability"));
var _ProductDetail = _interopRequireDefault(require("./ProductDetail01.styles"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const Accordion = (0, _component.default)(() => import("../../components/Accordion"));
const Description = (0, _component.default)(() => import("./Description"));
const Descriptions = (0, _component.default)(() => import("./Descriptions"));
const Documents = (0, _component.default)(() => import("./Documents"));
const Features = (0, _component.default)(() => import("./Features"));
const ProductDetail = (0, _component.default)(() => import("../../ProductDetail"));
const ProductSelection = (0, _component.default)(() => import("./ProductSelection"));
const Ratings = (0, _component.default)(() => import("./Ratings"));
const Recommendations = (0, _component.default)(() => import("./Recommendations"));
const References = (0, _component.default)(() => import("./References"));
const Content = _ref => {
  let {
    displayedFeatures,
    displayedAttributes,
    showAttributes,
    showBack,
    showBookmark,
    showReferences
  } = _ref;
  const [pageData] = (0, _react.useContext)(_PageContext.default);
  const {
    lang = "de"
  } = pageData || {};
  const {
    shopData
  } = (0, _react.useContext)(_ShopContext.default);
  const {
    setOpenCart
  } = (0, _react.useContext)(_CartContext.default);
  const {
    productDetailData
  } = (0, _react.useContext)(_ProductDetailContext.default);
  const {
    available,
    availableCount,
    descriptions,
    documents,
    features,
    maxQuantity,
    ratingActive = false,
    referenceIDs,
    type,
    _loading = false
  } = productDetailData || {};
  const [fetchDate, setFetchDate] = (0, _react.useState)(null);
  const [openReferences, setOpenReferences] = (0, _react.useState)(false);
  const theme = (0, _useTheme.default)();
  const isDesktop = (0, _useMediaQuery.default)(theme.breakpoints.up("md"));
  const css = (0, _ProductDetail.default)();
  const l = (0, _useLocals.default)({
    lang: lang,
    res: {
      de: _de.default,
      en: _en.default,
      it: _it.default
    }
  });
  (0, _react.useEffect)(() => {
    var _shopData$currency, _productDetailData$pr, _productDetailData$pr2;
    if ((0, _isEmpty.default)(productDetailData) || (0, _isEmpty.default)(shopData) || _loading) return;
    (0, _fireCustomEvent.default)("view_item", {
      ecommerce: {
        currency: shopData === null || shopData === void 0 || (_shopData$currency = shopData.currency) === null || _shopData$currency === void 0 ? void 0 : _shopData$currency.isoCode,
        value: productDetailData === null || productDetailData === void 0 || (_productDetailData$pr = productDetailData.price) === null || _productDetailData$pr === void 0 ? void 0 : _productDetailData$pr.amount,
        items: [{
          item_name: productDetailData === null || productDetailData === void 0 ? void 0 : productDetailData.title,
          item_variant: productDetailData === null || productDetailData === void 0 ? void 0 : productDetailData.combinationID,
          price: productDetailData === null || productDetailData === void 0 || (_productDetailData$pr2 = productDetailData.price) === null || _productDetailData$pr2 === void 0 ? void 0 : _productDetailData$pr2.amount
        }]
      }
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [_loading, JSON.stringify(shopData)]);
  const isAvailable = (0, _react.useMemo)(() => {
    return (0, _getAvailability.default)(available, availableCount);
  }, [available, availableCount]);
  const handleAdded = () => {
    if (!(0, _isEmpty.default)(referenceIDs)) {
      setOpenReferences(true);
      return;
    }
    setOpenCart(true);
  };
  return /*#__PURE__*/_react.default.createElement(_Container.default, {
    className: (0, _clsx.default)(css.productDetail, "mco-shop-product-detail"),
    maxWidth: "lg"
  }, showBack && /*#__PURE__*/_react.default.createElement(_BackButton.default, {
    lang: lang
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: css.wrapper
  }, !isDesktop && /*#__PURE__*/_react.default.createElement(_Gallery.default, {
    mediaFormats: {
      xs: "product-detail"
    }
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _clsx.default)(css.rightColumn, "mco-shop-product-detail__right-column")
  }, /*#__PURE__*/_react.default.createElement(_Tags.default, null), /*#__PURE__*/_react.default.createElement(_Title.default, null), /*#__PURE__*/_react.default.createElement(_ItemNumber.default, null), /*#__PURE__*/_react.default.createElement(_Price.default, {
    lang: lang
  }), /*#__PURE__*/_react.default.createElement(_Availability.default, {
    isAvailable: isAvailable,
    count: availableCount,
    lang: lang
  }), ratingActive && /*#__PURE__*/_react.default.createElement(_Rating.default, {
    key: fetchDate
  }), /*#__PURE__*/_react.default.createElement(Description, {
    lang: lang
  }), /*#__PURE__*/_react.default.createElement(ProductSelection, {
    lang: lang
  }, type === "voucher" ? /*#__PURE__*/_react.default.createElement(_VoucherSelection.default, {
    lang: lang
  }) : /*#__PURE__*/_react.default.createElement(_CombinationSelection.default, {
    displayedAttributes: displayedAttributes,
    lang: lang
  }), isAvailable && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
    className: "mco-shop-product-detail-buttons"
  }, type !== "voucher" && /*#__PURE__*/_react.default.createElement(_Quantity.default, {
    max: maxQuantity !== null && maxQuantity !== void 0 ? maxQuantity : availableCount
  }), /*#__PURE__*/_react.default.createElement(_CartButton.default, {
    displayedAttributes: displayedAttributes,
    lang: lang,
    onAdded: showReferences ? () => handleAdded() : null
  }), showBookmark && /*#__PURE__*/_react.default.createElement(_Bookmark.default, null))))), /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _clsx.default)(css.content, "mco-shop-product-detail__content")
  }, isDesktop && /*#__PURE__*/_react.default.createElement(_Gallery.default, {
    mediaFormats: {
      xs: "product-detail"
    }
  }), !(0, _isEmpty.default)(descriptions) && /*#__PURE__*/_react.default.createElement(Descriptions, null), !(0, _isEmpty.default)(features) && /*#__PURE__*/_react.default.createElement(Accordion, {
    defaultExpanded: false,
    title: l("reactShop.productDetail.title.features")
  }, /*#__PURE__*/_react.default.createElement(Features, {
    lang: lang
  })), !(0, _isEmpty.default)(documents) && type !== "voucher" && /*#__PURE__*/_react.default.createElement(Accordion, {
    defaultExpanded: false,
    title: l("reactShop.productDetail.title.documents")
  }, /*#__PURE__*/_react.default.createElement(Documents, {
    lang: lang
  })), ratingActive && /*#__PURE__*/_react.default.createElement(Accordion, {
    defaultExpanded: true,
    title: l("reactShop.productDetail.title.ratings")
  }, /*#__PURE__*/_react.default.createElement(Ratings, {
    key: fetchDate,
    lang: lang,
    setFetchDate: setFetchDate
  })))), !showReferences && !(0, _isEmpty.default)(referenceIDs) && /*#__PURE__*/_react.default.createElement("div", {
    className: css.recommendations
  }, /*#__PURE__*/_react.default.createElement(_Typography.default, {
    variant: "h4"
  }, /*#__PURE__*/_react.default.createElement(_Local.default, {
    identifier: "reactShop.productDetail.headlines.recommendations",
    l: l
  })), /*#__PURE__*/_react.default.createElement(Recommendations, {
    displayedFeatures: displayedFeatures,
    lang: lang,
    showBookmark: showBookmark
  })), showReferences && !(0, _isEmpty.default)(referenceIDs) && /*#__PURE__*/_react.default.createElement(References, {
    displayedFeatures: displayedFeatures,
    lang: lang,
    openReferences: openReferences,
    setOpenReferences: setOpenReferences,
    showAttributes: showAttributes
  }));
};
const ProductDetail01 = _ref2 => {
  let {
    defaultLang = "de",
    displayedAttributes = [],
    displayedFeatures = [],
    showAttributes = true,
    showBack = true,
    showBookmark = true,
    showReferences = false
  } = _ref2;
  const [pageData] = (0, _react.useContext)(_PageContext.default);
  const {
    lang: pageDataLang,
    setupDetails: data
  } = pageData || {};
  const [lang, setLang] = (0, _react.useState)(defaultLang);
  const isCurrentLocation = (0, _useIsCurrentLocation.default)();
  (0, _react.useEffect)(() => {
    if (!pageDataLang) return;
    setLang(pageDataLang);
  }, [pageDataLang]);
  if (!isCurrentLocation) return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null);
  return /*#__PURE__*/_react.default.createElement(ProductDetail, {
    data: data ? JSON.parse(data) : null,
    lang: lang,
    pagename: window.location.pathname
  }, /*#__PURE__*/_react.default.createElement(Content, {
    displayedAttributes: displayedAttributes,
    displayedFeatures: displayedFeatures,
    showBack: showBack,
    showBookmark: showBookmark,
    showReferences: showReferences
  }));
};
ProductDetail01.propTypes = {
  defaultLang: _propTypes.default.string,
  displayedAttributes: _propTypes.default.array,
  displayedFeatures: _propTypes.default.array,
  showBack: _propTypes.default.bool,
  showBookmark: _propTypes.default.bool,
  showReferences: _propTypes.default.bool
};
var _default = exports.default = ProductDetail01;